import { parseISO } from 'date-fns';
import type { MedicalGroupDetailDataObject, MedicalGroupListDataObject } from '../service';

export type MedicalGroupList = {
  createdAt: Date;
  id: string;
  identifiers?: {
    npi?: number;
  };
  name: string;
};

export const createMedicalGroupList = (data: MedicalGroupListDataObject): MedicalGroupList => ({
  createdAt: parseISO(data.createdAt),
  id: data._id,
  identifiers: data.identifiers,
  name: data.name,
});

export type MedicalGroupDetail = MedicalGroupList;

export const createMedicalGroupDetail = (data: MedicalGroupDetailDataObject): MedicalGroupDetail => ({
  ...createMedicalGroupList(data),
});
